<div class="card h-75" [class.card-border]="hasBorder">
  <div class="p-4" *ngIf="(tableTitle || gridViews) && !loading">
    <div class="row">
      <div class="col-6 pl-table-title">
        <h2
          *ngIf="gridViews && gridViews.length > 0; else defaultTitle"
          class="pointer"
          [matMenuTriggerFor]="titleMenu"
        >
          {{ tableTitle }}
          <mat-icon> arrow_drop_down </mat-icon>
        </h2>
        <ng-template #defaultTitle>
          <h2>{{ tableTitle }}</h2>
        </ng-template>
      </div>
      <div *ngIf="count > 0" class="col-6 text-right pl-table-header-action">
        <ng-content select="[header-actions]"></ng-content>
      </div>
    </div>
  </div>
  <div class="card-body" [hidden]="!cardBodyTemplate.children.length">
    <div #cardBodyTemplate class="table-filters">
      <ng-content></ng-content>
    </div>
  </div>
  <div *ngIf="loading">
    <ng-content select="[loading-template]"></ng-content>
  </div>
  <div class="p-md-sm" *ngIf="count === 0 && !loading">
    <div #customEmptyTemplate>
      <ng-content select="[empty-data]"></ng-content>
    </div>
    <div
      *ngIf="!customEmptyTemplate.children.length"
      class="pl-table-empty text-center"
    >
      There is no data
    </div>
  </div>
  <div class="table-responsive" [hidden]="count <= 0 || loading">
    <div class="pl-table-header">
      <mat-form-field class="pl-3" *ngIf="showSearch">
        <input
          matInput
          type="search"
          placeholder="Search this table"
          [formControl]="searchTerm"
          (keyup)="applyFilter()"
        />
        <mat-icon matSuffix (click)="resetSearch()">
          {{ searchTerm.value ? 'close' : 'search' }}</mat-icon
        >
      </mat-form-field>
      <ng-content select="[table-header]"></ng-content>
      <div class="pl-table-total-rows mr-4">
        <ng-container *ngIf="rowCount === 0; else totalDisplay">
          No records
        </ng-container>
        <ng-template #totalDisplay>
          {{ countDisplay?.prefix }} <strong>{{ rowCount }}</strong>
          {{ rowCount === 1 ? countDisplay.single : countDisplay.multiple }}
        </ng-template>
        <div *ngIf="countDisplay?.suffix">
          {{ countDisplay?.suffix }}
        </div>
      </div>
    </div>
    <mat-table
      mat-table
      matSort
      class="table"
      [dataSource]="dataSource"
      multiTemplateDataRows
    >
      <div *matNoDataRow class="p-md-sm">
        <div class="card-body">
          <div class="text-center p-6">
            <div class="m-3">
              <div class="image-container p-4">
                <img src="/assets/img/caseload/empty-search.png" />
              </div>
              <p class="p-2">
                Sorry, we found no matches
                <span *ngIf="searchTerm.value"
                  >for<br />
                  `{{ searchTerm.value }}`<br /><br
                /></span>
              </p>
              <ng-content select="[empty-search]"></ng-content>
            </div>
          </div>
        </div>
      </div>
      <ng-container [matColumnDef]="col.key" *ngFor="let col of columns">
        <mat-header-cell
          mat-sort-header
          *matHeaderCellDef
          [class]="col.style?.className"
          [style.maxWidth]="col.style?.width"
          [style.minWidth]="col.style?.minWidth"
          [style.flex]="col.flex || 1"
        >
          {{ col.label }}
        </mat-header-cell>
        <mat-cell
          *matCellDef="let element"
          [class]="col.style?.className"
          [style.maxWidth]="col.style?.width"
          [style.minWidth]="col.style?.minWidth"
          [style.flex]="col.flex || 1"
        >
          <ng-container [ngSwitch]="col.type">
            <span *ngSwitchCase="'date'">
              {{ element[col.key] | date: 'M/d/yyyy' }}
            </span>
            <span *ngSwitchCase="'time'">
              {{ formatTime(element[col.key]) }}
            </span>
            <ng-container *ngSwitchCase="'pill'">
              <div
                *ngIf="element[col.key]; else defaultColumnDisplay"
                class="pill-title {{ element[col.key] }}"
              >
                {{ element[col.key] }}
              </div>
            </ng-container>
            <ng-container
              *ngSwitchDefault
              [ngTemplateOutlet]="defaultColumnDisplay"
            >
            </ng-container>
          </ng-container>
          <ng-template #defaultColumnDisplay>
            <span class="cell-text">{{ element[col.key] }}</span>
          </ng-template>
        </mat-cell>
      </ng-container>
      <!-- Checkbox Column -->
      <ng-container matColumnDef="select">
        <mat-header-cell *matHeaderCellDef class="pl-table-checkbox">
          <mat-checkbox
            (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
          >
          </mat-checkbox>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="pl-table-checkbox">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(element) : null"
            [checked]="selection.isSelected(element)"
          >
          </mat-checkbox>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let element" class="justify-content-end">
          <ng-container *ngFor="let action of rowActions">
            <button
              *ngIf="action.icon; else labeledAction"
              mat-icon-button
              (click)="
                actionTriggered.emit({ name: action.name, value: element })
              "
            >
              <mat-icon>
                {{ action.icon }}
              </mat-icon>
            </button>
            <ng-template #labeledAction>
              <span
                class="pl-link"
                (click)="
                  actionTriggered.emit({ name: action.name, value: element })
                "
              >
                {{ action.label }}
              </span>
            </ng-template>
          </ng-container>
          <button
            *ngIf="expandable"
            mat-icon-button
            class="ml-2 no-focus"
            aria-label="expand row"
            (click)="
              expandedElementUuid =
                expandedElementUuid === element[uniqueColumn]
                  ? null
                  : element[uniqueColumn];
              $event.stopPropagation()
            "
          >
            <mat-icon *ngIf="expandedElementUuid !== element[uniqueColumn]"
              >keyboard_arrow_down</mat-icon
            >
            <mat-icon *ngIf="expandedElementUuid === element[uniqueColumn]"
              >keyboard_arrow_up</mat-icon
            >
          </button>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="expandedDetail">
        <mat-cell *matCellDef="let element">
          <ng-container
            *ngTemplateOutlet="
              expandableTemplate;
              context: { $implicit: element }
            "
          >
          </ng-container>
        </mat-cell>
      </ng-container>
      <mat-header-row
        *matHeaderRowDef="columnsDefinition; sticky: true"
        pl-sticky
      ></mat-header-row>
      <mat-row
        *matRowDef="let row; columns: columnsDefinition"
        [class.element-row]="expandable"
        [class.expanded-row]="
          expandable && expandedElementUuid === row[uniqueColumn]
        "
        [class.highlight]="isNewRow(row)"
        (click)="
          expandable
            ? (expandedElementUuid =
                expandedElementUuid === row[uniqueColumn]
                  ? null
                  : row[uniqueColumn])
            : actionTriggered.emit({ name: 'edit', value: row })
        "
      >
      </mat-row>
      <ng-container *ngIf="expandable">
        <mat-row
          *matRowDef="let row; columns: ['expandedDetail']"
          class="detail-row"
          [attr.id]="'expanded_detail_' + row[uniqueColumn]"
          [ngClass]="
            expandedElementUuid === row[uniqueColumn] ? 'expanded' : 'collapsed'
          "
        >
        </mat-row>
      </ng-container>
    </mat-table>
  </div>
  <mat-paginator
    [length]="count"
    [pageSize]="plDesign.settings.paginator.size"
    [pageSizeOptions]="plDesign.components.paginator.sizeOptions"
    *ngIf="pagination && count > 0"
    (page)="onPage($event)"
  >
  </mat-paginator>
</div>

<mat-menu #titleMenu="matMenu">
  <button mat-menu-item *ngFor="let view of gridViews" (click)="setView(view)">
    {{ view.label }}
  </button>
</mat-menu>
